import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, TableCell, TableRow, Typography } from "@mui/material";
import TableComponent from "../../../../component/Table/TableComponent";
import { formatAmount, formatGermanPercentage } from "../../../../helper/formatAmount";
import { getLiquiditätsbilanz2List, getLiquiditätsbilanzList } from "../../../../services/customer-services/customerLiquiditätsbilanz";

const columns = [
    { field: "aktiva", headerName: "Aktiva ||", translationKey: 'liquiditätsbilanz_aktiva' },
    { field: "aktivaWert", headerName: "Aktiva Wert", translationKey: 'liquiditätsbilanz_aktivaWert' },
    { field: "passiva", headerName: "Passiva ||", translationKey: 'liquiditätsbilanz_passiva' },
    { field: "passivaWert", headerName: "Passiva Wert", translationKey: 'liquiditätsbilanz_passiva_wert' },
];

const LiquiditätsbilanzTwo = () => {
    const { t } = useTranslation();
    const [liquidity2, setLiquidity2] = useState([]);
    const [totals, setTotals] = useState({});

    const getLiquiditätsbilanz = async () => {
        const response = await getLiquiditätsbilanz2List();
        if (response?.isSuccess) {
            setLiquidity2([...response.data]);
            setTotals(response?.totals);
        }
        else {
            setLiquidity2([]);
            setTotals({});
        }
    }

    useEffect(() => {
        getLiquiditätsbilanz()
    }, []);

    const totalRatio =
        totals?.totalPassivaWert && totals.totalPassivaWert !== 0
            ? (totals.totalAktivaWert / totals.totalPassivaWert) * 100
            : 0;

    return (
        <div>
            <Typography variant="h6" sx={{ padding: "0" }}>
                {t('liquiditätsbilanz_tab_two')}
            </Typography>
            <div>
                <TableComponent
                    data={liquidity2 ?? []}
                    columns={columns}
                    className={'table-max-height'}
                    hidePagination={false}
                >
                    {liquidity2?.map((row, rowIndex) => (
                        <TableRow key={rowIndex}>
                            <TableCell>{row.aktiva}</TableCell>
                            <TableCell>{formatAmount(row?.aktivaWert) + " €"}</TableCell>
                            <TableCell>{row?.passiva}</TableCell>
                            <TableCell>{formatAmount(row?.passivaWert) + " €"}</TableCell>
                        </TableRow>
                    ))}
                    {/* Add sum row */}
                    <TableRow sx={{ fontWeight: 'bold' }}>
                        <TableCell>{t('common_sum')}</TableCell>
                        <TableCell>{formatAmount(totals?.totalAktivaWert) + " €"}</TableCell>
                        <TableCell>{t('common_sum')}</TableCell>
                        <TableCell>{formatAmount(totals?.totalPassivaWert) + " €"}</TableCell>
                    </TableRow>
                </TableComponent>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        justifyContent: 'space-between',
                        alignItems: { xs: 'flex-start', md: 'center' },
                        gap: "1rem",
                        mt: "1.75rem"
                    }}
                >
                    <Typography>
                        {t('umsatzplanung_summe_von_aktiva')}
                        <Typography sx={{ fontSize: "1.5rem" }}>
                            {totals?.summeVonAktiva ? formatAmount(totals?.summeVonAktiva) : "0.00"} €
                        </Typography>
                    </Typography>
                    <Typography>
                        {t('umsatzplanung_summe_von_passiva')}
                        <Typography sx={{ fontSize: "1.5rem" }}>
                            {totals?.summeVonPassiva ? formatAmount(totals?.summeVonPassiva) : "0.00"} €
                        </Typography>
                    </Typography>
                    <Typography>
                        {t('liquiditätsbilanz_aktueller_insolvenzstatus')}
                        <Typography sx={{ fontSize: "1.5rem" }}>
                            {formatGermanPercentage(totalRatio)}%
                        </Typography>
                    </Typography>
                </Box>
            </div>
        </div>
    )
}

export default LiquiditätsbilanzTwo;
